import Vue from 'vue';
import Router from 'vue-router';

import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import ListLanguages from '@/pages/ListLanguages';
import ListGroups from '@/pages/ListGroups';
import Translations from '@/pages/Translations/Translations.vue';
import Backups from '@/pages/Backups';
import AddUser from '@/pages/AddUser';

Vue.use(Router);

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '*',
			redirect: '/',
		},
		{
			path: '/login',
			name: 'Login',
			component: Login,
		},
		{
			path: '/',
			name: 'Dashboard',
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/languages',
			name: 'ListLanguages',
			component: ListLanguages,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/groups',
			name: 'ListGroups',
			component: ListGroups,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/translations',
			name: 'Translations',
			component: Translations,
		},
		{
			path: '/backups',
			name: 'Backups',
			component: Backups,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/adduser',
			name: 'AddUser',
			component: AddUser,
			meta: {
				requiresAuth: true,
			},
		},
	],
});



// WEBPACK FOOTER //
// ./src/router/index.js